import { Box, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 79px:
 * 75px from theme.mixins.toolbar.maxHeight
 * 4px from layout contentContainer padding
 */
const useStyles = makeStyles(() => ({
	container: {
		height: 'calc(100vh - 79px)',
	},
}));

const NotFound: FC = () => {
	const classes = useStyles();

	const { t } = useTranslation('not_found');

	return (
		<Box
			className={classes.container}
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
		>
			<Typography variant="h3" color="textSecondary">
				{t('title')}
			</Typography>
			<Typography variant="body1" color="textSecondary">
				{t('text')}
			</Typography>
		</Box>
	);
};

export default NotFound;
